var Screen = "Screen";
var ScreenContainer = "ScreenContainer";
export {
  Screen,
  ScreenContainer
};
//# sourceMappingURL=react-native-screens.js.map
